var $e5aa0186ca7889c6$exports = {};
$e5aa0186ca7889c6$exports = {
  "dateRange": function dateRange(args) {
    return "De la ".concat(args.startDate, " p\xE2n\u0103 la ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " selectat\u0103");
  },
  "finishRangeSelectionPrompt": "Ap\u0103sa\u0163i pentru a finaliza selec\u0163ia razei pentru dat\u0103",
  "maximumDate": "Ultima dat\u0103 disponibil\u0103",
  "minimumDate": "Prima dat\u0103 disponibil\u0103",
  "next": "Urm\u0103torul",
  "previous": "\xCEnainte",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Dat\u0103 selectat\u0103: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Interval selectat: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Ap\u0103sa\u0163i pentru a \xEEncepe selec\u0163ia razei pentru dat\u0103",
  "todayDate": function todayDate(args) {
    return "Ast\u0103zi, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Azi, ".concat(args.date, " selectat\u0103");
  }
};
export { $e5aa0186ca7889c6$exports as default };